import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";

// Auth Pages
import AdminLogin from "./pages/auth/AdminLogin";
import LifeSaverLogin from "./pages/auth/LifeSaverLogin";

// Admin Pages
import AdminDashboard from "./pages/admin/Dashboard";
import LifeSaverManagement from "./pages/admin/LifeSaverManagement";
import CommunicationManagement from "./pages/admin/CommunicationManagement";
import VideoManagement from "./pages/admin/VideoManagement";
import StatusManagement from "./pages/admin/StatusManagement";
import AdminProfile from "./pages/admin/AdminProfile";
import MemberMessages from "./pages/admin/MemberMessages";

// Member Pages
import LifeSaverDashboard from "./pages/member/Dashboard";
import MyProfile from "./pages/member/MyProfile";
import MyCommunications from "./pages/member/MyCommunications";
import CommunicateToAdmin from "./pages/member/CommunicateToAdmin";

import "./App.css";

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <ToastContainer position="top-right" autoClose={3000} />
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<Navigate to="/admin/login" replace />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/member/login" element={<LifeSaverLogin />} />

            {/* Admin Protected Routes */}
            <Route
              path="/admin/dashboard"
              element={
                <ProtectedRoute allowedRoles={["admin"]}>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/life-savers"
              element={
                <ProtectedRoute allowedRoles={["admin"]}>
                  <LifeSaverManagement />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/communications"
              element={
                <ProtectedRoute allowedRoles={["admin"]}>
                  <CommunicationManagement />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/videos"
              element={
                <ProtectedRoute allowedRoles={["admin"]}>
                  <VideoManagement />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/status"
              element={
                <ProtectedRoute allowedRoles={["admin"]}>
                  <StatusManagement />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/member-messages"
              element={
                <ProtectedRoute allowedRoles={["admin"]}>
                  <MemberMessages />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/profile"
              element={
                <ProtectedRoute allowedRoles={["admin"]}>
                  <AdminProfile />
                </ProtectedRoute>
              }
            />

            {/* Member Protected Routes */}
            <Route
              path="/member/dashboard"
              element={
                <ProtectedRoute allowedRoles={["member"]}>
                  <LifeSaverDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/member/profile"
              element={
                <ProtectedRoute allowedRoles={["member"]}>
                  <MyProfile />
                </ProtectedRoute>
              }
            />
            <Route
              path="/member/communications"
              element={
                <ProtectedRoute allowedRoles={["member"]}>
                  <MyCommunications />
                </ProtectedRoute>
              }
            />
            <Route
              path="/member/contact-admin"
              element={
                <ProtectedRoute allowedRoles={["member"]}>
                  <CommunicateToAdmin />
                </ProtectedRoute>
              }
            />

            {/* 404 */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
